import React from 'react';
import PropTypes from 'prop-types';

import Button from '../common/button/Button';
import Message from '../common/message/Message';
import Spacer from '../common/spacer/Spacer';
import { ProgressItem } from './ProgressItem';
import { ProgText } from './ProgText';
import { ProgHead } from './ProgHead';

import { PROGRESS } from '../../constants/ProgressStates';

const Interview = ({
    status,
    hasUrl,
    onButtonClick
}) => {
    return (
        <React.Fragment>
            {status !== PROGRESS.COMPLETE &&
                <React.Fragment>
                    <ProgHead code="epic.esport.step1.background.title" />
                    <ProgText code="epic.esport.step1.background.content1" />
                    <ProgText code="epic.esport.step1.background.content2" />
                    <ProgText code="epic.esport.step1.background.content3" />

                    <ProgHead code="epic.esport.step1.minor.title" />
                    <ProgText code="epic.esport.step1.minor.content" />

                    <ProgHead code="epic.esport.step1.reqs.title" />
                    <ProgText code="epic.esport.step1.reqs.list" />

                    <Spacer as="ul" bottom={24}>
                        <Message as="li" code="epic.esport.step1.reqs.item1" />
                        <Message as="li" code="epic.esport.step1.reqs.item2" />
                        <Message as="li" code="epic.esport.step1.reqs.item3" />
                        <Message as="li" code="epic.esport.step1.reqs.item4" />
                        <ul>
                            <Message as="li" code="epic.esport.step1.tin.list1" />
                            <Message as="li" code="epic.esport.step1.tin.list2" />
                            <ul>
                                <Message as="li" code="epic.esport.step1.tin.item1" />
                                <Message as="li" code="epic.esport.step1.tin.item2" />
                                <Message as="li" code="epic.esport.step1.tin.item3" />
                                <Message as="li" code="epic.esport.step1.tin.item4" />
                                <Message as="li" code="epic.esport.step1.tin.item5" />
                                <Message as="li" code="epic.esport.step1.tin.item6" />
                            </ul>
                        </ul>
                    </Spacer>
                </React.Fragment>
            }

            {status !== PROGRESS.COMPLETE && hasUrl &&
                <Button onClick={onButtonClick}>
                    <Message fragment code="epic.esport.actions.startTaxInterview" />
                </Button>
            }
            {status === PROGRESS.COMPLETE &&
                <React.Fragment>
                    <ProgHead code="epic.esport.step1.done.title" />
                    <ProgText code="epic.esport.step1.done.content" />
                </React.Fragment>
            }
        </React.Fragment>
    );
};

Interview.propTypes = {
    status: PropTypes.oneOf(Object.values(PROGRESS)),
    hasUrl: PropTypes.bool,
    onButtonClick: PropTypes.func
};

const Release = ({status, onButtonClick, isCash}) => {
    return (
        <React.Fragment>
            <ProgHead code="epic.esport.step1.release.notMinor.title" />
            <ProgText code="epic.esport.step1.release.notMinor.content" />

            <ProgHead code="epic.esport.step1.release.minor.title" />
            <ProgText code="epic.esport.step1.release.minor.content1" />
            {
                isCash ? <ProgText code="epic.esport.step1.release.minor.content2" /> :
                    <ProgText code="epic.esport.step1.release.minor.content2.pg" />
            }
            {status !== PROGRESS.COMPLETE &&
                <Button onClick={onButtonClick}>
                    <Message fragment code="epic.esport.actions.signReleaseForm" />
                </Button>
            }
        </React.Fragment>
    );
};

Release.propTypes = {
    status: PropTypes.oneOf(Object.values(PROGRESS)),
    onButtonClick: PropTypes.func,
    isCash: PropTypes.bool
};

export const Step1 = props => {
    const {
        hasUrl,
        isCash,
        isRelease,
        onButtonClick,
        status = PROGRESS.INCOMPLETE,
        ...otherProps
    } = props;

    const titleCode = isRelease ? 'epic.esport.step1.release.title' : 'epic.esport.step1.title';

    return (
        <ProgressItem
            status={status}
            step={1}
            title={<Message fragment code={titleCode} />}
            {...otherProps}
        >
            {isRelease
                ? <Release isCash={isCash} status={status} onButtonClick={onButtonClick} />
                : <Interview status={status} onButtonClick={onButtonClick} hasUrl={hasUrl} />
            }
        </ProgressItem>
    );
};

Step1.displayName = 'Step1';

Step1.propTypes = {
    hasUrl: PropTypes.bool,
    isRelease: PropTypes.bool,
    onButtonClick: PropTypes.func,
    status: PropTypes.string,
    isCash: PropTypes.bool
};
